import { useState, useEffect } from 'react';
import styles from './TopButton.module.css';
import { FiArrowUp } from 'react-icons/fi';

function TopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // 스크롤 위치가 300px 이상일 때 버튼 표시
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            className={`${styles.topButton} ${isVisible ? styles.visible : ''}`}
            onClick={scrollToTop}
            aria-label="맨 위로 이동"
        >
            <FiArrowUp size={24} />
        </button>
    );
}

export default TopButton;

